module.exports = __webpack_public_path__ + "img/5.ee0f85ef.png";